// extracted by mini-css-extract-plugin
export default {"element":"style-module--element--e1ad5","elementSize":"style-module--elementSize--3fac8"};